import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAddressCard,
  faArrowRightToCity,
  faArrowsToDot,
  faChevronLeft,
  faBarsProgress,
  faBed,
  faBell,
  faBookOpen,
  faBookDead,
  faBug,
  faChair,
  faCheck,
  faCheckDouble,
  faCheckSquare,
  faChevronRight,
  faCloudMoon,
  faCog,
  faComment,
  faCopy,
  faClipboard,
  faDice,
  faDragon,
  faExchangeAlt,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileCode,
  faFileUpload,
  faFilter,
  faFilterCircleXmark,
  faGavel,
  faHandBackFist,
  faHandPaper,
  faHandPointRight,
  faHandScissors,
  faHandSparkles,
  faHashtag,
  faHeartbeat,
  faHouseUser,
  faImage,
  faLandmarkDome,
  faLink,
  faMinusCircle,
  faMinusSquare,
  faMusic,
  faPaperPlane,
  faPeopleArrows,
  faPlay,
  faPlusCircle,
  faQuestion,
  faRandom,
  faRankingStar,
  faRedoAlt,
  faRightToBracket,
  faSearchMinus,
  faSearchPlus,
  faSkull,
  faSquare,
  faStickyNote,
  faTheaterMasks,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTowerBroadcast,
  faTrashAlt,
  faUndo,
  faUser,
  faUserEdit,
  faUserFriends,
  faUserSecret,
  faUsers,
  faVenusMars,
  faVolumeUp,
  faVolumeMute,
  faVoteYea,
  faWindowMaximize,
  faWindowMinimize,
  faYinYang,
} from "@fortawesome/free-solid-svg-icons";
import {
  faDocker,
  faDiscord,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { App } from "vue";

library.add(
  faAddressCard,
  faArrowRightToCity,
  faArrowsToDot,
  faChevronLeft,
  faChevronRight,
  faBarsProgress,
  faBed,
  faBell,
  faBookOpen,
  faBookDead,
  faBug,
  faChair,
  faCheck,
  faCheckDouble,
  faCheckSquare,
  faCloudMoon,
  faCog,
  faComment,
  faCopy,
  faClipboard,
  faDice,
  faDragon,
  faExchangeAlt,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileCode,
  faFileUpload,
  faFilter,
  faFilterCircleXmark,
  faGavel,
  faHandBackFist,
  faHandPaper,
  faHandPointRight,
  faHandScissors,
  faHandSparkles,
  faHashtag,
  faHeartbeat,
  faHouseUser,
  faImage,
  faLandmarkDome,
  faLink,
  faMinusCircle,
  faMinusSquare,
  faMusic,
  faPaperPlane,
  faPeopleArrows,
  faPlay,
  faPlusCircle,
  faQuestion,
  faRandom,
  faRankingStar,
  faRedoAlt,
  faRightToBracket,
  faSearchMinus,
  faSearchPlus,
  faSkull,
  faSquare,
  faStickyNote,
  faTheaterMasks,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTowerBroadcast,
  faTrashAlt,
  faUndo,
  faUser,
  faUserEdit,
  faUserFriends,
  faUserSecret,
  faUsers,
  faVenusMars,
  faVolumeUp,
  faVolumeMute,
  faVoteYea,
  faWindowMaximize,
  faWindowMinimize,
  faYinYang,
  faDiscord,
  faDocker,
  faGithub,
);

export default {
  install(app: App) {
    app.component("FontAwesomeIcon", FontAwesomeIcon);
  },
};
